import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { BntService } from './bnt.service';

angular.module('app-lite.bnt', [])
  .service('bntApi', downgradeInjectable(BntService));
